
export { Feedback };

let Feedback = {
    
    init() {
        let $form = $('.feedback-form'),
            nodeId = $form.find('input[name=node_id]').val(),
            cookieRegex = new RegExp(`SALEHOO\\[FeedbackSubmitted\\]\\[\\d+_${nodeId}\\]`);

        // fallback before view cache expires
        if (cookieRegex.test(document.cookie)) {
            $form.closest('.feedback-form-box').remove();
            return;
        }

        $('.yes-feedback-submit').click(function (e) {
            $('form.yes-feedback').submit();
        });

        $form.find('button[type="submit"]').prop('disabled', true);
        $form.find('textarea').on('change, keyup', function (e) {
            $form.find('button[type="submit"]:visible').prop('disabled', !$.trim($(e.currentTarget).val()));
        });

        $('body').on('submit', '.feedback-form', function (e) {
            e.preventDefault();

            let $form = $(e.currentTarget),
                $button = $form.find('button[type="submit"]');

            $button.prop('disabled', true);

            $.post(
                '/feedback',
                $form.serialize(),
                null,
                'json'
            ).done(function (response) {
                if (!response.success) {
                    alert('Oops! It seems like there was an error or you have already submitted your feedback. '
                         + 'Please check and try again later.')
                    return;
                }

                $button.prop('disabled', false);
                $('.feedback-thankyou-box').removeClass('d-none');
                
                if ($form.find('input[name="hide_form"]').val() == 1) {
                    $('.feedback-form-box').addClass('d-none');
                } else {
                    $('.feedback-form-box').find('h5, .row-btn').addClass('d-none');
                }
            });

            return false;
        });

        $('.btn-copy').on('click', (e) => {
            e.preventDefault();
            $('input#shareUrl').select();
            if (document.queryCommandSupported('copy') && document.queryCommandEnabled('copy')) {
                try {
                    document.execCommand('copy');
                    alert('Link copied!');
                } catch (err) {
                    // Fail gracefully
                }
            }
        });
    }

}